import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "", address: "" });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    // Validate phone — must be at least 10 digits (PH mobile numbers are 10–13 digits after stripping)
    const digits = (form.phone || "").replace(/\D/g, "");
    if (digits.length < 10) {
      toast.error("Please enter a valid mobile number (at least 10 digits)");
      return;
    }
    setLoading(true);
    const res = await register(form);
    setLoading(false);
    if (!res.ok) { toast.error(res.error); return; }
    toast.success("Welcome to Arbe Minimart!");
    nav("/shop");
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 sm:px-6 py-8 sm:py-12 page-enter">
      <div className="w-full max-w-md bg-white border border-[#E1E5DF] rounded-2xl p-6 sm:p-8 shadow-[0_10px_40px_rgba(0,0,0,0.05)]">
        <div className="flex justify-center mb-4">
          <img src="/assets/arbe-logo.png" alt="Arbe" className="h-14 w-14 object-contain" />
        </div>
        <h1 className="font-heading text-3xl font-extrabold text-[#1C2826] text-center tracking-tighter">Create an account</h1>
        <p className="text-center text-[#4A5D5A] mt-1 text-sm">Fast checkout, order tracking, and local delivery.</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label>Full name</Label>
            <Input value={form.name} onChange={update("name")} className="mt-1.5 h-11" required data-testid="register-name" />
          </div>
          <div>
            <Label>Email</Label>
            <Input type="email" value={form.email} onChange={update("email")} className="mt-1.5 h-11" required data-testid="register-email" />
          </div>
          <div>
            <Label>Password</Label>
            <Input type="password" value={form.password} onChange={update("password")} className="mt-1.5 h-11" required minLength={6} data-testid="register-password" />
          </div>
          <div>
            <Label>Mobile number <span className="text-[#C62828]">*</span></Label>
            <Input type="tel" value={form.phone} onChange={update("phone")} className="mt-1.5 h-11" placeholder="09XX-XXX-XXXX" required data-testid="register-phone" />
            <p className="text-[11px] text-[#738380] mt-1">Required — we use this to confirm delivery and send your delivery code.</p>
          </div>
          <div>
            <Label>Default address (optional)</Label>
            <Textarea value={form.address} onChange={update("address")} rows={2} className="mt-1.5" data-testid="register-address" />
          </div>
          <Button disabled={loading} type="submit" className="w-full h-11 bg-[#2F5233] hover:bg-[#1F3D24] text-white rounded-full font-semibold" data-testid="register-submit">
            {loading ? "Creating..." : "Create account"}
          </Button>
        </form>
        <div className="mt-5 text-center text-sm text-[#4A5D5A]">
          Already have one? <Link to="/login" className="text-[#2F5233] font-medium hover:underline" data-testid="go-login">Log in</Link>
        </div>
      </div>
    </div>
  );
}
